export default {
      id: "precent-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#precent",
      toString: function () {
        return this.url;
      }
    }